export default __webpack_public_path__ + "static/media/frame_beige_yellow.d2d9acd5.png";